import { render } from "./reportcolours.vue?vue&type=template&id=3a228628&scoped=true"
import script from "./reportcolours.vue?vue&type=script&lang=js"
export * from "./reportcolours.vue?vue&type=script&lang=js"

import "@/assets/css/ts-table.css?vue&type=style&index=0&id=3a228628&scoped=true&lang=css&external"
import "./reportcolours.vue?vue&type=style&index=1&id=3a228628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a228628"]])

export default __exports__